const swiper = new Swiper('.slider-product', {
    loop: false,
    spaceBetween: 20,
    pagination: {
        el: '.swiper-pagination',
    },
    breakpoints: {  
        321: {  
            slidesPerView: 1,  
        },  
        768: {  
            slidesPerView: 2,  
        },  
        1024: {  
            slidesPerView: 3,  
        },
        1440: {  
            slidesPerView: 4,  
        }
    } 
});

